export default "__VITE_ASSET__76cbf0a3__"